// import * as types from './actionTypes';

import axios from 'axios';
import firebase from '../firebase';
var moment = require('moment');
require('moment-timezone');


/*these url environment constants below (REACT_APP_DEV_API_URL and REACT_APP_PROD_API_URL ) determine where you api requests will go.

 When you develop locally, you will need to create a '.env' in  root directory 
 and assign the values to these constants.
 
 If the production address of your api changes you will need to change the REACT_APP_PROD_API_URL's  value in this app's settings in AWS under Config Vars.

*/
if(process.env.NODE_ENV === "development"){
    axios.defaults.baseURL = process.env.REACT_APP_DEV_API_URL;
}
else{
    axios.defaults.baseURL = process.env.REACT_APP_PROD_API_URL;
}

let defaultUser = '73728e65fc58aec82b6';


/*all of our post requests to the api will be a json type.
we are enabling cossDomain becuase the api could be hosted in a different domain.
if you don't assign it's value to true, the requeets will be dropperd */

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.crossDomain = true;

//hide and reset all alerts
export function hideAlerts(){
    return(dispatch)=>{
        dispatch({type:"HIDE_ALERTS"})
    }
}

//update usernames for display
export function updateAuth(userName, id, userEmail){
    var userData  = {userName:userName, id: id, userEmail:userEmail}
    return (dispatch) => {
        dispatch({type: "AUTH_SUCCESS", data:userData})
    }
};

export function updateAuthLogOut(userName){
    return (dispatch) => {
        dispatch({type: "LOGOUT_SUCCESS"})
    }
};

export function currentNode(node,limit, fromDate, toDate){
    var canberraTime = moment();
        return (dispatch) => {
            dispatch({type: "CURRENT_NODE_INFO", node:node, limit:limit, fromDate:fromDate, toDate:canberraTime.unix()})
        }
}


// this is a firebase request.
/** 
 * Send a reser email the subject user. 
 * @param {string} userEmail the subject user's email address
*/
export function sendResetEmail(userEmail){
    return (dispatch) => {

        firebase.fireAuth.sendPasswordResetEmail(userEmail).then((res) =>{
            console.log('yes')
            dispatch({type: "EMAIL_RESET_SENT"})
        }).catch(err =>{
            dispatch({type: "EMAIL_RESET_FAIL"})
        })
        
    } 
}


//the functions below make requests to the API


/** 
 * Request a new API Key
 * @param {string} user the subject user's username
 * @param {string} id the subject user's id
 * @param {string} org the subject user's organisation
*/
export function newToken(user, id, org){
    return (dispatch) => {
        return axios({
                method:'post',
                url:'/tokengen?userId='+ id,
                data: {
                    userName: user,
                    subjectId: id,
                    org:org
                  }
              })
        .then((response) => {
            if(response.status === 201){

                dispatch({type: "TOKEN_SUCCESS", data:response.data})
                // console.log(response.data)
            }
            else{
                dispatch({type: "TOKEN_FAILURE", data:response.data}) 
            }
            
        }).catch((err)=>{
            dispatch({type: "TOKEN_FAILURE", data:err.message}
        )}
            
        )
        
      };
}

/** 
 * Get  available API
 * @param {string} id the subject user's id
*/
export function getTokens(id){

    return (dispatch) => {
        return axios({
                method:'post',
                url:'/getTokens?userId='+ id,
                data: {
                    subjectId: id
                  }
              })
        .then((response) => {
            if(response.status === 200){
                dispatch({type: "GET_TOKEN_SUCCESS", data:response.data})
            }
            else{
                dispatch({type: "GET_TOKEN_FAILURE", data:response.data}) 
            }
            
        }).catch((err)=>{
            dispatch({type: "GET_TOKEN_FAILURE", data:err.message}
        )}
            
        )
        
      };

}


/** 
 * Request node data for a selected time period for a specific forest. Used for the the main graph. 
 * @param {string} forest the forest search string e.g. F023 Example Forest
 * @param {int, float} timeframe data for the last X days(s) e.g. 2 or 0.5
 * @param {int} from lower end of the filer date as a UTC unix timestamp
 * @param {int} to upper end of the filer date as a UTC unix timestamp
*/
export function getNodeData(forest, timeframe, from, to){
    return (dispatch) => {
        return axios({
                method:'get',
                url:"/nodedata/"+from+"/"+to+"?forest="+forest+"&days="+timeframe+"&userId="+defaultUser +  "&org=National Arboretum Canberra",
              })
        .then((response) => {
            // let upload_times = []
            if(response.status === 200){
                let newData = response.data.data;
                    Object.keys(newData).forEach(node =>{
                        
                        newData[node].forEach((item) =>{
                            //for matting the unix timestamp to readable Canberra time
                            item.vwc30 ? item.vwc30 =  Math.round((item.vwc30*100) * 100) / 100 : null
                            item.vwc60 ? item.vwc60  =  Math.round((item.vwc60*100) * 100) / 100: null
                            item.battery_voltage = Math.round((item.battery_voltage*100)) ;
                            item.battery = (Math.min(100, Math.max(0, item.battery_voltage)));
                            delete item.battery_voltage
                        });
                    })
                let parsedData = {data:newData, count:response.data.count, meta:response.data.meta}
                dispatch({type: "GET_NODE_DATA_SUCCESS", data:parsedData})
            }
            else{
                let parsedData = {data:response.data.data, count:response.data.count,meta:response.data.meta}
                dispatch({type: "GET_NODE_DATA_FAILURE", data:parsedData}) 
            }
            
        }).catch((err)=>{
            console.log(err)
            dispatch({type: "GET_NODE_DATA_FAILURE", data:err.message}
        )}
            
        )
        
      };

} 

/** 
 * Request node data for a selected time period for a specific node. Used for the map popup graphs. 
 * @param {string} nodeNum the node number being quueried. e.g. 1, 2, 11 etc.
 * @param {int} timeframe data for the last X days(s) e.g. 3
 * @param {int} from lower end of the filer date as a UTC unix timestamp
 * @param {int} to upper end of the filer date as a UTC unix timestamp
*/
export function getNodeGraphData(nodeNum, timeframe, from, to){
    return (dispatch) => {
        return axios({
                method:'get',
                url:"/nodedata/"+from+"/"+to+"?nodeNum="+nodeNum+"&days="+timeframe+"&userId="+defaultUser  + "&org=National Arboretum Canberra",
              })
        .then((response) => {
            // let upload_times = []
            if(response.status === 200){
                let newData = response.data.data;
                Object.keys(newData).forEach(node =>{
                    newData[node].forEach((item) =>{
                        //for matting the unix timestamp to readable Canberra time
                        item.vwc30 = item.vwc30 && Math.round((item.vwc30*100) * 100) / 100;
                        item.vwc60  = item.vwc30 && Math.round((item.vwc60*100) * 100) / 100;
                        item.battery_voltage = Math.round((item.battery_voltage*100)) ;
                        item.battery = (Math.min(100, Math.max(0, item.battery_voltage)));
                        delete item.battery_voltage
                    });
                })
                let parsedData = {data:newData[(Object.keys(newData)[0])], count:response.data.count}
                dispatch({type: "GET_NODE_GRAPH_DATA_SUCCESS", data:parsedData})
            }
            else{
                let parsedData = {data:response.data.data, count:response.data.count}
                dispatch({type: "GET_NODE_GRAPH_DATA_FAILURE", data:parsedData}) 
            }
            
        }).catch((err)=>{
            console.log(err)
            dispatch({type: "GET_NODE_GRAPH_DATA_FAILURE", data:err.message}
        )}
            
        )
        
      };

}

/** 
 * Get metadata fro each node i.e. node number, forest number, physical location, thresholds etc. 
*/
export function getNodeInfo(){
    return (dispatch) =>{
        return axios({
            method:'get',
            url:"/nodeinfo?userId="+ defaultUser + "&org=National Arboretum Canberra",
          })
        .then(response =>{
            let status = response.status;
            if(status === 200 || status === 304){
                dispatch({type: "NODE_INFO_SUCCESS", data:response.data})
            }else{
                dispatch({type: "NODE_INFO_FAILURE"})
            }
        })
    }
}

/** 
 * Post a bug report. 
 * @param {string} val The report string. 
 * @param {string} user the subject user's id
*/

export function reportBug(val, user){
    return (dispatch) =>{
        return axios({
            method:'post',
            url:"/bug?userId=" + user,
            data: {
                report: String(val),
                subjectId:user
              }
          })
        .then(response =>{
            let status = response.status;
            if(status === 200 || status === 201){
                dispatch({type: "BUG_REPORT_SUCCESS"})
            }else{
                dispatch({type: "BUG_REPORT_FAILURE"})
            }
        }).catch(err =>{
            dispatch({type: "BUG_REPORT_FAILURE"})
        })
    }
}
/** 
 * Get metadata for each node along with the current vwc state. i.e. node number, forest number, physical location, thresholds etc. 
*/
export function getMapNodeInfo(){
    return (dispatch) =>{
        return axios({
            method:'get',
            url:"/nodeinfo?userId="+ defaultUser + "&org=National Arboretum Canberra",
          })
        .then(response =>{
            let status = response.status;
            if(status === 200 || status === 304){
                dispatch({type: "MAP_NODE_INFO_SUCCESS", data:response.data})
            }else{
                dispatch({type: "MAP_NODE_INFO_FAILURE"})
            }
        })
    }
}
/** 
 * Get baic info of the active user. 
 * @param {string} id Id for the subject user. 
*/
export function getUserInfo(id){
    return (dispatch) =>{
        return axios({
            method:'get',
            url:"/user?userId="+ id + "&subjectId=" + id,
          })
        .then(response =>{
            let status = response.status;
            if(status === 200 || status === 304){
                dispatch({type: "USER_INFO_SUCCESS", data:response.data})
            }else{
                dispatch({type: "USER_INFO_FAILURE"})
            }
        }).catch((err) =>{
            dispatch({type: "USER_INFO_FAILURE"})
        })
    }
}

/** 
 * Get the Sensor Network's Duty cycle change logs.  
 * @param {string} id Id for the subject user. 
*/
export function getSleepLogs(requestor){
    return (dispatch) =>{
        return axios({
            method:'get',
            url:"/sleeplog?userId=" + requestor + "&org=National Arboretum Canberra",
          })
        .then(response =>{
            let status = response.status;
            if(status === 200 || status === 304){
                dispatch({type: "SLEEP_INFO_SUCCESS", data:response.data})
            }else{
                dispatch({type: "SLEEP_INFO_FAILURE"})
            }
        })
    }
}
/** 
 * Add a new user to the database.  
 * @param {string} userId the new user's id (generated in firebase)
 * @param {string} accessLevel the access level requested by the user
 * @param {string} organisation the organmisation selected by the user
 * @param {string} userName the username selected by the user. 
 * @param {string} emailAddress the email address seleted by the user.
*/

export function addUser(userId, accessLevel, organisation, userName, emailAddress){
    return (dispatch) =>{
        return axios({
            method:'post',
            url:"/user?userId=" + defaultUser,
            data: {
                subjectId: userId,
                accessLevel:accessLevel,
                organisation:organisation,
                userName:userName || emailAddress, 
                emailAddress: emailAddress
              }
          })
        .then(response =>{
            let status = response.status;
            if(status === 201 || status === 202){
                dispatch({type: "ADD_USER_SUCCESS", data:response.data})
            }else{
                dispatch({type: "ADD_USER_FAILURE"})
            }
        }).catch(err =>{
            dispatch({type: "ADD_USER_FAILURE"})
        })
    }
}
/** 
 * Edit exising user in the database  
 * @param {string} userId the user's id (generated in firebase)
 * @param {string} accessLevel the new access level requested by the user
 * @param {string} organisation the organmisation selected by the user
 * @param {string} userName the username selected by the user. 
 * @param {string} emailAddress the email address seleted by the user.
*/
export function editUser(userId, accessLevel, organisation, userName, emailAddress){
    return (dispatch) =>{
        return axios({
            method:'post',
            url:"/users?userId=" + defaultUser,
            data: {
                subjectId: userId,
                accessLevel:accessLevel,
                organisation:organisation,
                userName:userName || emailAddress, 
                emailAddress: emailAddress
              }
          })
        .then(response =>{
            console.log(response)
            let status = response.status;
            if(status === 201){
                dispatch({type: "EDIT_USER_SUCCESS", data:response.data})
            }else{
                dispatch({type: "EDIT_USER_FAILURE"})
            }
        }).catch(err =>{
            dispatch({type: "EDIT_USER_FAILURE"})
        })
    }
}
/** 
 * Edit exising node information in the database  
 * @param {string} userId the requesting user's id
 * @param {string} orgId the requesting user's organisation id
 * @param {string} nodeId the id for the subject node
 * @param {Object} nodeData node data. 
*/
export function editNode (userId, orgId, nodeId, nodeData){
    return (dispatch) =>{
        return axios({
            method:'post',
            url:'/nodeinfoe?userId=' + userId + '&orgId=' + orgId + '&nodeId=' + nodeId,
            data: {
                nodeData: nodeData
              }
          })
        .then(response =>{
            console.log(response)
            let status = response.status;
            if(status === 201){
                dispatch({type: "EDIT_NODE_SUCCESS", data:response.data})
            }else{
                dispatch({type: "EDIT_NODE_FAILURE"})
            }
        }).catch(err =>{
            console.log(err)
            dispatch({type: "EDIT_NODE_FAILURE"})
        })
    }
}
/** 
 * Manually add a new node and relevant information in the database  
 * @param {string} userId the requesting user's id
 * @param {string} orgId the requesting user's organisation id
 * @param {string} nodeId the id for the subject node
 * @param {Object} nodeData the new node data. 
*/
export function addNode (userId, orgId, nodeId, nodeData){
    return (dispatch) =>{
        return axios({
            method:'post',
            url:'/nodeinfo?userId=' + userId + '&orgId=' + orgId + '&nodeId=' + nodeId,
            data: {
                nodeData: nodeData
              }
          })
        .then(response =>{
            let status = response.status;
            if(status === 201){
                dispatch({type: "ADD_NODE_SUCCESS", data:response.data})
            }else{
                dispatch({type: "ADD_NODE_FAILURE"})
            }
        }).catch(err =>{
            dispatch({type: "ADD_NODE_FAILURE"})
        })
    }
}
/** 
 * Manually override the current duty cycle of the network. 
 * @param {int} value the new duty cycle in munite(s) i.e. 1, 10 etc. 
 * @param {string} user the requesting user's id
*/

export function changeSleepTime(value, user){

    return (dispatch) => {
        return axios({
                method:'post',
                url:'/sleeptime',
                data: {
                    newTime: value,
                    subjectId:user,
                    source:"user"
                  }
              })
        .then((response) => {
            if(response.status === 201){
                dispatch({type: "CHANGE_SLEEP_SUCCESS"})
            } else{
                dispatch({type: "CHANGE_SLEEP_FAILURE"})
            }
            
        }).catch((err)=>{
            dispatch({type: "CHANGE_SLEEP_FAILURE"}
        )}
            
        )
        
      };
}


// end api requests



// WEBPACK FOOTER //
// ./src/actions/actions.js